<template>
  <div class="message_top" v-if="operate.getActionType().value == OperateType.mgx">
    <Transition name="message-slide">
      <div class="message_mgx_status_wrapper" v-if="magnetSet.keysInfoReading.value">
        <div class="message_mgx_status">
          <div class="loading_icon">
            <SvgAsset :content="actionLoadingSvg" />
          </div>
          {{ $t('reading_key_trip') }}
        </div>
      </div>
    </Transition>
  </div>
</template>
<script lang="ts">
export const currentCalibratin = ref('')
</script>
<script setup lang="ts">
import { OperateType, operate } from '@/service/driver/operate'
import SvgAsset from '../common/SvgAsset.vue'
import actionLoadingSvg from '@/assets/inline-svg/action-loading.svg?raw'
import { ref, watch } from 'vue'
import { magnetSet } from '@/service/driver/magnet_set'
import { DeviceManager } from '@/service/device'
import { specialCheck, speciaBehiver } from '@/define/limit'

watch(
  () => DeviceManager.instance.state.currentPid,
  () => {
    operate.fnCheck.value = false
  },
)
</script>
<style lang="less" scoped>
.message_top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0;
  z-index: 100;
  pointer-events: none;
  display: flex;
  justify-content: center;
}

.message_mgx_status_wrapper {
  margin-top: 30px;
  background: var(--brand-color);
  padding: 8px 16px;
  border-radius: var(--radius-m);
  box-shadow: var(--action-btn-primary-shadow);
  pointer-events: auto;
}

.message_mgx_status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;

  .loading_icon {
    width: 16px;
    height: 16px;
    animation: rotate 1s linear infinite;

    .svg_asset {
      width: 100%;
      height: 100%;
    }
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.message-slide-enter-active,
.message-slide-leave-active {
  transition: all 0.4s var(--transition-base);
}

.message-slide-enter-from,
.message-slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
